"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _context = require("../../context");

var _styled = require("./styled");

var _color = require("../../../../styles/helpers/color");

var _hooks = require("../../../../libs/hooks");

var _color2 = _interopRequireDefault(require("./color"));

var DefaultColors = /*#__PURE__*/_react["default"].forwardRef(function (_props, ref) {
  var _useContext = (0, _react.useContext)(_context.ColorPickerContext),
      colors = _useContext.colors,
      rgba = _useContext.rgba,
      tabIndexProp = _useContext.tabIndex,
      onChange = _useContext.onChange;

  var rgbaColor = (0, _color.recomposeColor)({
    type: 'rgba',
    values: rgba
  });
  var name = (0, _hooks.useUniqueIdentifier)('color-picker-default');
  var listColors = colors.map(function (color, index) {
    var tabIndex = index === 0 ? tabIndexProp : -1;
    var isSelected = (0, _color.colorToRgba)(color) === rgbaColor;
    var isFirstInput = index === 0;
    var inputRef = isFirstInput ? ref : undefined;
    return /*#__PURE__*/_react["default"].createElement(_color2["default"], {
      key: color,
      color: color,
      name: name,
      isChecked: isSelected,
      onChange: onChange,
      ref: inputRef,
      tabIndex: tabIndex
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_styled.StyledContainer, null, /*#__PURE__*/_react["default"].createElement(_styled.StyledColors, null, listColors));
});

var _default = DefaultColors;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/ColorPicker/commons/defaultColors/index.js
// module id = bD1/
// module chunks = 0